import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ZorroLayoutComponent } from './theme/layouts/zorro-layout.component';
import { AuthorizedGuard } from './guard/authorized.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'auth' },
  {
    path: 'auth',
    loadChildren: () =>
      import('./pages/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'admin',
    component: ZorroLayoutComponent,
    canActivate: [AuthorizedGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./pages/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./pages/users/users-view.module').then(
            (m) => m.UsersViewModule
          ),
      },
      {
        path: 'categories',
        loadChildren: () =>
          import('./pages/categories/categories.module').then(
            (m) => m.CategoriesModule
          ),
      },
      {
        path: 'publications',
        loadChildren: () =>
          import('./pages/publications/publication.module').then(
            (m) => m.PublishersModule
          ),
      },
      {
        path: 'articles',
        loadChildren: () =>
          import('./pages/articles/articles.module').then(
            (m) => m.ArticlesModule
          ),
      },
      {
        path: 'roles',
        loadChildren: () =>
          import('./pages/roles/roles.module').then((m) => m.RolesModule),
      },
      {
        path: 'permissions',
        loadChildren: () =>
          import('./pages/permissions/permissions.module').then(
            (m) => m.PermissionsModule
          ),
      },
      {
        path: 'withdrawal',
        loadChildren: () =>
          import('./pages/withdrawal/withdrawal.module').then(
            (m) => m.WithdrawalModule
          ),
      },
      {
        path: 'global-settings',
        loadChildren: () =>
          import('./pages/global-settings/global-settings.module').then(
            (m) => m.GlobalSettingsModule
          ),
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./pages/orders/orders.module').then((m) => m.OrdersModule),
      },
      {
        path: 'email-compose',
        loadChildren: () =>
          import('./pages/email-compose/email-compose.module').then(
            (m) => m.EmailComposeModule
          ),
        canActivate: [AuthorizedGuard]
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}